import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { CHECKBOX_DEFAULT_VALUE } from "./checkbox.script";
import "./checkbox.script";
export function RuiCheckbox({
  children,
  checked,
  disabled,
  indeterminate,
  name,
  value = CHECKBOX_DEFAULT_VALUE,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-checkbox", {
    ...props,
    checked,
    disabled,
    indeterminate,
    name,
    value,
    children: /* @__PURE__ */jsxs("label", {
      class: "rui-checkbox",
      children: [/* @__PURE__ */jsx("input", {
        type: "checkbox",
        "data-ref": "input",
        "data-rui-control": true,
        "data-rui-control-type": "boolean",
        class: "rui-checkbox__input",
        checked,
        disabled,
        value,
        name: name || void 0,
        "aria-checked": indeterminate ? "mixed" : void 0
      }), /* @__PURE__ */jsx("span", {
        class: "rui-checkbox__control",
        "aria-hidden": "true"
      }), /* @__PURE__ */jsx("span", {
        class: "rui-checkbox__label",
        children
      })]
    })
  });
}